/* CELESTIAR — avis.js : avis vérifiés (commande Shopify) avec photo, publiés après validation */
(function () {
  "use strict";
  var I18N = window.CELESTIAR_I18N || {};
  var LOCALE = I18N.locale === "en" ? "en-GB" : "fr-FR";
  var API = String(window.CELESTIAR_API || "").replace(/\/$/, "");
  if (!API) return;
  var PRODUCT = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || "";
  function esc(s) { return String(s || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  var STAR = '<svg viewBox="0 0 24 24" width="14" height="14" fill="#E8D5A3" aria-hidden="true"><path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.7 7.1L12 17.6 5.7 21.3l1.7-7.1L2 9.5l7.1-.6z"/></svg>';

  var form = document.querySelector("[data-avis-form]");
  if (form) {
    form.setAttribute("enctype", "multipart/form-data");
    try {
      var q = new URLSearchParams(window.location.search);
      var qo = q.get("commande"), qe = q.get("email");
      if (qo) form.querySelector('[name="order_name"]').value = qo.charAt(0) === "#" ? qo : "#" + qo;
      if (qe) form.querySelector('[name="email"]').value = qe;
      if (qo || qe) { var t = form.querySelector('[name="name"]'); if (t) t.focus(); }
    } catch (e) {}
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[type=submit]");
      var err = form.querySelector("[data-avis-error]");
      if (err) err.style.display = "none";
      if (btn) { btn.disabled = true; btn.textContent = I18N.review_sending || "Envoi en cours…"; }
      var fd = new FormData();
      fd.append("name", form.querySelector('[name="name"]').value);
      fd.append("email", form.querySelector('[name="email"]').value);
      fd.append("order_name", form.querySelector('[name="order_name"]').value);
      fd.append("rating", form.querySelector('[name="rating"]').value || "5");
      fd.append("message", form.querySelector('[name="message"]').value);
      var file = form.querySelector('[name="photo"]');
      if (file && file.files && file.files[0]) fd.append("photo", file.files[0]);
      fetch(API + "/reviews", { method: "POST", body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(typeof res.d.detail === "string" ? res.d.detail : "");
          form.innerHTML = '<p class="gift-prefill-note" data-testid="review-success-message">✦ ' + esc(res.d.message) + "</p>";
        })
        .catch(function (ex) {
          if (btn) { btn.disabled = false; btn.textContent = I18N.review_submit || "Envoyer mon avis"; }
          if (err) { err.textContent = ex.message || (window.CELESTIAR_I18N && window.CELESTIAR_I18N.locale === "en" ? "Unable to send right now — please try again or email us at contact@celestiar.fr." : "Envoi impossible pour le moment — réessayez ou écrivez-nous à contact@celestiar.fr."); err.style.display = "block"; }
        });
    });
  }

  var zone = document.querySelector("[data-reviews-live]");
  var footerLink = document.querySelector("[data-footer-reviews-link]");
  var badge = document.querySelector("[data-avis-badge]");
  if (!zone && !footerLink && !badge) return;
  fetch(API + "/reviews/latest" + (PRODUCT && !zone ? "?product=" + encodeURIComponent(PRODUCT) : ""))
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (!d || !d.count) return;
      if (zone) {
        var section = zone.closest("[data-reviews-section]");
        if (section) section.hidden = false;
        zone.innerHTML = '<div class="reviews-grid" style="display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:18px">' + d.items.map(function (a) {
          var date = a.created_at ? new Date(a.created_at).toLocaleDateString(LOCALE, { month: "long", year: "numeric" }) : "";
          var photo = a.photo_url ? '<img src="' + esc(a.photo_url) + '" alt="' + (window.CELESTIAR_I18N && window.CELESTIAR_I18N.locale === "en" ? "Frame received by " : "Photo du cadre reçu par ") + esc(a.name) + '" loading="lazy" style="width:100%;aspect-ratio:4/3;object-fit:cover;border-radius:10px;margin-bottom:10px">' : "";
          return '<article class="card review-card" data-testid="review-card">' + photo +
            '<div class="review-card__stars">' + STAR.repeat(Math.max(1, Math.min(5, a.rating))) + "</div>" +
            '<p class="review-card__text">« ' + esc(a.message) + " »</p>" +
            '<p class="review-card__author">' + esc(a.name) + (date ? " · " + date : "") + ' · <span style="color:#E8D5A3">' + (window.CELESTIAR_I18N && window.CELESTIAR_I18N.locale === "en" ? "Verified purchase" : "Achat vérifié") + '</span></p>' +
            "</article>";
        }).join("") + "</div>";
      }
      if (footerLink) footerLink.hidden = false;
      if (badge) {
        badge.innerHTML = '<span class="avis-badge__stars">' + STAR.repeat(Math.round(d.average)) + "</span>" +
          '<span class="avis-badge__score">' + (I18N.locale === "en" ? String(d.average) : String(d.average).replace(".", ",")) + "/5</span>" +
          '<a href="' + ((window.CELESTIAR_I18N||{}).root||"/").replace(/\/$/,"") + '/pages/avis" class="avis-badge__link">' + (I18N.review_count || "__COUNT__ avis").replace("__COUNT__", d.count) + "</a>";
        badge.classList.add("is-visible");
      }
    })
    .catch(function () {});
})();
